export default function getOrganizationUsersReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'FETCH_ORGANIZATION_USERS_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'FETCH_ORGANIZATION_USERS_ERROR':
            return {...state, ...{ error: action.error }};

        case 'FETCH_ORGANIZATION_USERS_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}